import React from "react";
import { Link } from "react-router-dom";
import { BarChart3 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { getReportsPath } from "@/pages/reports/reportModules";

/**
 * Quick link to a module's report hub from list pages.
 * @param {{ moduleId: string, mode?: string, to?: string, className?: string }} props
 */
const ReportsNavButton = ({ moduleId, mode = "export", to, className = "" }) => {
    const { t } = useTranslation();
    const path = to ?? getReportsPath(moduleId, mode);

    return (
        <Link
            to={path}
            className={`inline-flex items-center gap-2 rounded-lg border border-blue-500/30 bg-blue-500/10
                        px-3 py-2 text-sm font-medium text-blue-600 no-underline transition-colors
                        hover:bg-blue-500/20 dark:text-blue-400 ${className}`}
            data-testid="nav-reports-manager"
        >
            <BarChart3 className="h-4 w-4" />
            {t("reports")}
        </Link>
    );
};

export default ReportsNavButton;
